import { useSelector } from 'react-redux';
import WithPermission from '../WithPermission/WithPermission';
import { canManageProductActions } from 'src/lib/utils';
import { userSelector } from 'src/store/apps/slices/UserSlice';

/**
 * Product mutation UI gate: existing permission AND Yangon (or Root Admin).
 * Use for create/edit/delete/activate/import/export/price/par-level mutations.
 * Do NOT use for list/view/detail-only controls.
 *
 * Backend APIs enforce the same Yangon / Root Admin rule.
 */
const WithProductActionPermission = ({ permission, children, fallback = null }) => {
  const { user } = useSelector(userSelector);

  return (
    <WithPermission
      permission={permission}
      and={canManageProductActions(user)}
      fallback={fallback}
    >
      {children}
    </WithPermission>
  );
};

export default WithProductActionPermission;
